import Actions               from 'Redux/Actions';
import { InvoiceRepository } from 'Domain/Repositories';
import { ofType }            from 'redux-observable';
import { from }              from 'rxjs';
import { mergeMap }          from 'rxjs/operators';
import { TEpic }             from 'Redux/Config';

export const findInvoicesEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findInvoicesRequest.type),
    mergeMap(action => from(
      InvoiceRepository.findAll(action.payload)
        .then(({ invoices, meta }) => Actions.findInvoicesSuccess({ invoices, maxCount: meta?.count }))
        .catch((error: Error) => Actions.findInvoicesFailure({ error })),
    )),
  );
};
